module.exports = __webpack_public_path__ + "static/media/werecat.6a7b9af6.jpg";